<template>
  <span class="timer-style-page">
    <span>
      {{ hours | formatValue }}h : {{ minutes | formatValue }}m
      <!-- {{ seconds | formatValue }} -->
    </span>
  </span>
</template>
<script>
import global from '../../../mixins/global';

export default {
  name: 'CheckInClock',
  filters: {
    formatValue (val) {
      if (val === null) {
        return '00';
      } else {
        return val;
      }
    },
  },
  mixins: [global],
  data () {
    return {
      hours: null,
      minutes: null,
      seconds: null,
      timerInterval: null,
    };
  },
  computed: {
    workTimerLastUpdatedAt () {
      return this.$store.getters['devices/getWorkTimerUpdatedAt'];
    },
  },
  watch: {
    workTimerLastUpdatedAt (val) {
      this.setClock();
    },
  },
  mounted () {
    this.setClock();
  },
  beforeDestroy () {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  },
  methods: {
    async setClock () {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }

      var checkInTime = localStorage.getItem('checkInTime');
      if (checkInTime === null) {
        this.hours = null;
        this.minutes = null;
        this.seconds = null;
        return;
      }
      this.timerInterval = setInterval(this.StartClock, 1000);
    },
    async StartClock () {
      var checkInTime = localStorage.getItem('checkInTime');
      if (checkInTime === null) {
        this.hours = null;
        this.minutes = null;
        this.seconds = null;
        return;
      }
      var parsedCheckInTime = JSON.parse(checkInTime);
      var updatedTime = +new Date();
      this.difference = updatedTime - parsedCheckInTime;
      var hours = Math.floor(
        (this.difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      var minutes = Math.floor(
        (this.difference % (1000 * 60 * 60)) / (1000 * 60),
      );
      var seconds = Math.floor((this.difference % (1000 * 60)) / 1000);

      this.hours = hours < 10 ? '0' + hours : hours;
      this.minutes = minutes < 10 ? '0' + minutes : minutes;
      this.seconds = seconds < 10 ? '0' + seconds : seconds;
    },
  },
};
</script>
<style scoped>
.timer-header {
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;
  font-family: "Times New Roman", Times, serif;
}
.timer-style-page {
  color: #272727;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
</style>
